<template>
  <template v-if="leads.length"
    ><Lead v-for="lead in leads" :key="lead.id" :lead="lead"
  /></template>
  <div v-else :class="$style.empty">Нет лидов :(</div>
</template>

<script>
import Lead from "./Lead.vue";
export default {
  data() {
    return {};
  },
  components: {
    Lead,
  },
  computed: {
    leads() {
      return this.$store.state.leads.leads;
    },
  },
};
</script>

<style lang="scss" module>
.empty {
  text-align: center;
  padding: 2rem 0 0.5rem 0;
  color: $t-secondary;
}
</style>
